module.exports = __webpack_public_path__ + "img/zm.112bea3.svg";